import {defineStore} from 'pinia'
import {PaginatedData} from '@/stores/index'
import type Feedback from '@/types/api/feedback.type'
import api from '@/api'
import type {FeedbackListParams} from '@/api/modules/feedbacks'

interface State {
  feedbacks: PaginatedData<Feedback>
}

export const useFeedbackStore = defineStore('feedback', {
  // see https://pinia.vuejs.org/core-concepts/state.html
  state: (): State => ({
    // define initial values
    feedbacks: new PaginatedData<Feedback>(),
  }),
  // see https://pinia.vuejs.org/core-concepts/getters.html
  getters: {
    // define getters to access compound or calculated data
  },
  // see https://pinia.vuejs.org/core-concepts/actions.html
  actions: {

    /**
         * load feedbacks
         * @param {FeedbackListParams} config - the config for the call
         * @param cancel
         * @param requestID
         */
    async loadFeedbacks(config: FeedbackListParams, cancel = true, requestID?: string) {
      const id = requestID || api.feedbacks.getFeedbacks.name
      if (cancel)
        api.feedbacks.cancel(id)
      this.feedbacks.pending = true
      return api.feedbacks.cancelableCall(api.feedbacks.getFeedbacks, config, id)
        .then((data) => {
          const page = data.data
          this.feedbacks.total = page.count
          this.feedbacks.data = page.results
          if (!api.feedbacks.hasPending(id))
            this.feedbacks.pending = false
        }).catch((error) => {
          if (!api.feedbacks.hasPending(id))
            this.feedbacks.pending = false
          throw error
        })
    },

    /**
         * resets the store to the initial state.
         */
    clearFeedbacks() {
      this.$reset()
    },
  },
})
